import React from 'react';
import { SwiperSlide } from 'swiper/react';

import { Carousel, CarouselWrapper, CarouselPagination } from '$partials/base/carousel';
import { SimpleImage } from '$partials/media';
import { PropertyAreaText, PropertyPriceText } from '$partials/properties';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/items.d.ts').FeaturedPropertyListingItem}
 */
const FeaturedPropertyListingItem = (props) => {
    return (
        <article className='w-full theme-light-alt bg-main-background'>
            <div className='layout-container layout-site-outer-padding py-24 md:py-48'>
                <div className='col-wrapper'>
                    <p className='type-style-eyebrow col-padding mb-24 sm:pb-16'>Featured</p>

                    <div className='flex flex-col gap-y-16 sm:flex-row'>
                        <div className='sm:w-6/12 md:w-7/12 h-full col-padding'>
                            <div className='w-full h-full overflow-hidden relative'>
                                <Carousel
                                    swiperConfig={{
                                        a11y: { enabled: true },
                                        slidesPerView: 1,
                                        spaceBetween: 0,
                                    }}>
                                    <CarouselWrapper>
                                        {props?.images?.map((item) => {
                                            return (
                                                <SwiperSlide
                                                    aria-roledescription='slide'
                                                    className='select-none cursor-pointer w-full h-full relative'
                                                    key={item.id}
                                                    role='group'>
                                                    <SimpleImage
                                                        className='w-full h-full object-cover aspect-[3/2]'
                                                        {...item.media?.image}/>
                                                </SwiperSlide>
                                            );
                                        })}

                                        {props?.images?.length > 1 && (
                                            <CarouselPagination totalSlides={props.images.length} />
                                        )}
                                    </CarouselWrapper>
                                </Carousel>
                            </div>
                        </div>

                        <div className='col-padding gap-y-16 sm:col-padding-r md:w-4/12 flex flex-col justify-between'>
                            {props?.displayAddress && (
                                <div>
                                    {(props.price || props.isOffMarket) &&
                                        <div className='flex flex-col h-20 justify-center w-fit mb-16'>
                                            <div className='bg-tag-main-background border border-tag-main-border rounded flex h-24 items-center justify-center px-8 py-8'>
                                                <p className='type-style-eyebrow text-main-brand-text'>
                                                    {props.isOffMarket && 'Off market'}

                                                    <PropertyPriceText
                                                        isOffMarket={props.isOffMarket}
                                                        pageType={props.__typename}
                                                        price={props.price}
                                                        priceCurrency={props.priceCurrency}
                                                        priceRentPeriod={props.priceRentPeriod} />
                                                </p>
                                            </div>
                                        </div>
                                    }

                                    <p className='type-style-eyebrow text-main-text-secondary '>
                                        {props.displayAddress}
                                    </p>

                                    {/* Bed/Bath/livingAreaMeters Details */}
                                    <div className='flex gap-16 items-center type-style-eyebrow text-main-text-primary mt-4'>
                                        {props.bedrooms && (
                                            <p className='shrink-0'>
                                                {props.bedrooms} bed
                                            </p>
                                        )}
                                        {props.bathrooms && (
                                            <p className='shrink-0'>
                                                {props.bathrooms} bath
                                            </p>
                                        )}
                                        {props.livingAreaMeters && (
                                            <p className='shrink-0'>
                                                <PropertyAreaText
                                                    areaMeters={props.livingAreaMeters}
                                                    isOffMarket={props.isOffMarket} />
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                            {props?.title && (
                                <a
                                    className='type-style-2 text-main-text-primary whitespace-pre-wrap'
                                    href={props?.url}>
                                    {props?.title}
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </article>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default FeaturedPropertyListingItem;
